import { Grid, TextField, Typography } from "@mui/material";
import { Producer } from "../types";

interface ProducersComponentModulesProps {
  producers: Producer[];
  isEditing: boolean;
  // handleProducersChange: (updatedProducers: Producer[]) => void;
  setIsEditing: (value: boolean) => void;
  handleProducersModules: (updatedProducers: Producer[]) => void;
}

const ProducersComponetModules: React.FC<ProducersComponentModulesProps> = ({
  producers,
  isEditing,

  handleProducersModules,
}) => {
  const handleTextFieldChange = <K extends keyof Producer>(
    index: number,
    field: K,
    value: Producer[K]
  ) => {
    const updatedProducers = [...producers];
    updatedProducers[index][field] = value;

    // Chama a função passada como prop para atualizar os dados no componente pai
    handleProducersModules(updatedProducers);

    console.log("Dados Alterados PRODUCERS MOD:", updatedProducers);
  };

  return (
    <>
      {producers.map((producer, index) => (
        <Grid container item key={index} spacing={2}>
          <Grid
            item
            xs={6}
            textAlign={"start"}
            sx={{
              paddingX: "20px",
              marginTop: "30px",
            }}
          >
            <Typography sx={{ marginBottom: "8px" }}>
              Fabricante {index + 1}
            </Typography>
          </Grid>

          <Grid container spacing={2} sx={{ padding: "20px" }}>
            {isEditing ? (
              <>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    size="small"
                    label={`Telefone de Contato - ${index + 1}`}
                    variant="outlined"
                    value={producer.contactPhone}
                    onChange={(e) =>
                      handleTextFieldChange(
                        index,
                        "contactPhone",
                        e.target.value
                      )
                    }
                    style={{ fontSize: 16 }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    size="small"
                    label={`Email de Contato - ${index + 1}`}
                    variant="outlined"
                    value={producer.contactEmail}
                    onChange={(e) =>
                      handleTextFieldChange(
                        index,
                        "contactEmail",
                        e.target.value
                      )
                    }
                    style={{ fontSize: 16 }}
                  />
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    disabled
                    size="small"
                    label={`Telefone de Contato - ${index + 1}`}
                    variant="outlined"
                    value={producer.contactPhone}
                    onChange={(e) =>
                      handleTextFieldChange(
                        index,
                        "contactPhone",
                        e.target.value
                      )
                    }
                    style={{ fontSize: 16 }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    disabled
                    size="small"
                    label={`Email de Contato - ${index + 1}`}
                    variant="outlined"
                    value={producer.contactEmail}
                    onChange={(e) =>
                      handleTextFieldChange(
                        index,
                        "contactEmail",
                        e.target.value
                      )
                    }
                    style={{ fontSize: 16 }}
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12} md={3}>
              {/* <Button type="submit" onClick={handleSaveAndExitEditMode}>
                Salvar Dados
              </Button> */}
            </Grid>
          </Grid>
        </Grid>
      ))}
    </>
  );
};
export default ProducersComponetModules;
